import { handleBonusNotificationInfo } from '../../../common/handleBonusNotificationInfo';

export const bonusNoConfirmationNotificationInfo = async (
    { actionInfo, actionId },
    { games, lang, syncClose, dispatch }
) =>
    handleBonusNotificationInfo({ actionInfo, actionId, isConfirmation: false }, {
        games,
        lang,
        syncClose,
        dispatch
    });
